import React from 'react';

export type IconName =
  | 'taps' | 'book' | 'notes' | 'cooler' | 'search'
  | 'sun' | 'moon' | 'pin' | 'plus' | 'check'
  | 'arrow-right' | 'arrow-left' | 'close' | 'alert'
  | 'menu' | 'user' | 'clock' | 'swap' | 'trash' | 'filter' | 'pencil' | 'key';

interface IconProps {
  name: IconName;
  size?: number;
  stroke?: number;
  className?: string;
}

export function Icon({ name, size = 18, stroke = 1.6, className }: IconProps): React.ReactElement | null {
  const props = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none' as const,
    stroke: 'currentColor',
    strokeWidth: stroke,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    className,
  };
  switch (name) {
    case 'taps': return (
      <svg {...props}>
        <path d="M4 5h12v4H4z"/><path d="M10 9v6"/>
        <path d="M7 19h6l-1-4H8z"/><path d="M16 7h3a2 2 0 0 1 2 2v2"/>
      </svg>
    );
    case 'book': return (
      <svg {...props}><path d="M4 4h10a4 4 0 0 1 4 4v12H8a4 4 0 0 1-4-4V4z"/><path d="M4 16a4 4 0 0 1 4-4h10"/></svg>
    );
    case 'notes': return (
      <svg {...props}><path d="M5 4h11l3 3v13H5z"/><path d="M9 10h6M9 14h6M9 18h4"/></svg>
    );
    case 'cooler': return (
      <svg {...props}><rect x="4" y="3" width="16" height="18" rx="1.5"/><path d="M4 9h16"/><path d="M9 13v3M15 13v3"/></svg>
    );
    case 'search': return (
      <svg {...props}><circle cx="11" cy="11" r="6"/><path d="m20 20-4.3-4.3"/></svg>
    );
    case 'sun': return (
      <svg {...props}><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>
    );
    case 'moon': return (
      <svg {...props}><path d="M20 14.5A8 8 0 0 1 9.5 4 8 8 0 1 0 20 14.5z"/></svg>
    );
    case 'pin': return (
      <svg {...props}><path d="M9 3h6l-1 5 3 4H7l3-4z"/><path d="M12 12v9"/></svg>
    );
    case 'plus': return (<svg {...props}><path d="M12 5v14M5 12h14"/></svg>);
    case 'check': return (<svg {...props}><path d="m5 12 5 5 9-11"/></svg>);
    case 'arrow-right': return (<svg {...props}><path d="M5 12h14M13 5l7 7-7 7"/></svg>);
    case 'arrow-left': return (<svg {...props}><path d="M19 12H5M11 5l-7 7 7 7"/></svg>);
    case 'close': return (<svg {...props}><path d="M6 6l12 12M18 6L6 18"/></svg>);
    case 'alert': return (<svg {...props}><path d="M12 4 2 20h20z"/><path d="M12 10v5M12 18v.01"/></svg>);
    case 'menu': return (<svg {...props}><path d="M3 6h18M3 12h18M3 18h18"/></svg>);
    case 'user': return (<svg {...props}><circle cx="12" cy="8" r="4"/><path d="M4 21a8 8 0 0 1 16 0"/></svg>);
    case 'clock': return (<svg {...props}><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>);
    case 'swap': return (<svg {...props}><path d="M7 7h13l-3-3M17 17H4l3 3"/></svg>);
    case 'trash': return (<svg {...props}><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13"/></svg>);
    case 'filter': return (<svg {...props}><path d="M3 5h18l-7 9v6l-4-2v-4z"/></svg>);
    case 'pencil': return (
      <svg {...props}><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4z"/></svg>
    );
    case 'key': return (
      <svg {...props}>
        <circle cx="7" cy="15" r="4"/>
        <path d="m21 3-9.5 9.5"/>
        <path d="m16 5 2 2-3.5 3.5-2-2"/>
      </svg>
    );
    default: return null;
  }
}
